/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SmartSmsRequestStatus {
  Done = 0,
  Waiting = 1,
  Failed = 2,
  Invalid = 3,
  Expired = 4,
  Active = 5,
  InActive = 6,
  PartOfRequestIsCompleted = 7,
  Finished = 8
}
